import './app.css';
import '@babel/polyfill';

import WebFont from 'webfontloader';
import lazySizes from 'lazysizes';
import {analyticsEvent, attrEvents} from './js/analytics';
// import VanillaTilt from 'vanilla-tilt';

import './video/1.mp4';
import './video/1.webm';
import './video/2.mp4';
import './video/2.webm';
import './video/3.mp4';
import './video/3.webm';
import './video/4.mp4';
import './video/4.webm';
import './video/5.mp4';
import './video/5.webm';
import './video/6.mp4';
import './video/6.webm';
import './video/7.mp4';
import './video/7.webm';
import './video/8.mp4';
import './video/8.webm';

/* is production */
const isProd = process.env.NODE_ENV === 'production';

/* service worker */
if ('serviceWorker' in navigator && isProd) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('./sw.js');
    });
}

/* fonts */
WebFont.load({
    custom: {
        families: ['DINPro:n4,n7', 'BebasNeue:n7'],
        urls: ['./css/fonts.css']
    }
});

/* analytics (EXAMPLE: analyticsEvent('Button', 'click', 'Play');) */
analyticsEvent();
attrEvents();

/* lazy loading (https://github.com/aFarkas/lazysizes) */
lazySizes.init();

/* trailer */
{
    [...document.querySelectorAll('[data-dialog="trailer"]')].forEach(button => {
        button.addEventListener('click', e => {
            e.preventDefault();

            import(/* webpackPrefetch: true */ './js/trailer').then(func => {
                func.default();
            });

            analyticsEvent('Button', 'click', 'Trailer Play');
        });
    });
}

/* webp pics */
{
    const webpBackgrounds = (webp = false) => {
        [...document.querySelectorAll('[data-webp]')].forEach(item => {
            item.style.backgroundImage = `url(img/${item.dataset.webp}.${webp ? 'webp' : 'png'})`;
        });
    };

    async function supportsWebp() {
        if (!self.createImageBitmap) return false;

        const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
        const blob = await fetch(webpData).then(r => r.blob());
        return createImageBitmap(blob).then(() => true, () => false);
    }

    (async () => {
        if (await supportsWebp()) {
            webpBackgrounds(true);
        } else {
            webpBackgrounds(false);
        }
    })();
}

/* tilt */
{
    // VanillaTilt.init(document.querySelector('.intro-move'));
}

/* start test */
{
    document.querySelector('.button--start').addEventListener('click', () => {
        const switchToTest = () => {
            document.querySelector('.main').setAttribute('data-state', 'test');

            import(/* webpackPrefetch: true */ './js/questions').then(func => {
                func.default();
            });
        };

        if (window.matchMedia('(max-width: 1023px) and (orientation: portrait)').matches) {
            switchToTest();
        } else {
            document.querySelector('.intro').setAttribute('data-state', 'loading');

            window.setTimeout(switchToTest, 1400);
        }
    });
}

/* share buttons */
{
    document.querySelector('.controls__toggle').addEventListener('click', () => {
        document.querySelector('.controls__share').classList.toggle('controls__share--show');

        import(/* webpackPrefetch: true */ './js/share').then(shareHandler => {
            shareHandler.default([...document.querySelectorAll('.controls__share .share__item')]);
        });
    });
}
